import React from 'react';
import PropTypes from 'prop-types';

import withErrorContainer from '@zr/components/withErrorContainer';

import {
  // these fields aren't profile jso fields, but are transformed into the profile date fields
  useExperienceFormikSubmit,
} from '@zr/jobseeker-public/apps/profile-form/utilities/experienceFormUtilities';

import useAddAnotherRef from '@zr/jobseeker-public/apps/profile-form/utilities/useAddAnotherRef';

import WorkExperienceForm from './WorkExperienceForm';

import './ScreenViewWrapper.less';
import './WorkExperience.less';

export function WorkExperience({
  disabled, method, onAddAnother, onContinue, onError, onErrorClose, enableRichText, setIsLoading,
}) {
  const [addAnotherRef, setAddAnother, setNoMore] = useAddAnotherRef();

  const [numExperiencesAdded, handleFormSubmit] = useExperienceFormikSubmit(
    addAnotherRef,
    setIsLoading, {
      method,
      onAddAnother,
      onNoMore: onContinue,
      onError,
      onStartSubmit: onErrorClose,
    },
  );

  return (
    <WorkExperienceForm
      enableRichText={enableRichText}
      disabled={disabled}
      handleFormSubmit={handleFormSubmit}
      numExperiencesAdded={numExperiencesAdded}
      onContinue={onContinue}
      setAddAnother={setAddAnother}
      setNoMore={setNoMore}
    />
  );
}

WorkExperience.propTypes = {
  disabled: PropTypes.bool,
  method: PropTypes.string,
  onAddAnother: PropTypes.func,
  onContinue: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onErrorClose: PropTypes.func.isRequired,
  enableRichText: PropTypes.bool,
  setIsLoading: PropTypes.func,
};

WorkExperience.defaultProps = {
  disabled: false,
  method: null,
  onAddAnother: () => {},
  enableRichText: false,
  setIsLoading: () => {},
};

export default withErrorContainer(WorkExperience);
